// GTM Programmes, GTM Approval and GTM Tracker — the screen's strings in the portal's four languages (2026-10-21).
const en = {
  pdfFailed: "Could not make the PDF.",
  savedBefore: "{{error}} ({{n}} saved before this)",
  colFold: "Expand",
};
const ko = {
  pdfFailed: "PDF를 만들 수 없습니다.",
  savedBefore: "{{error}} (이전에 {{n}}건 저장됨)",
  colFold: "펼치기",
};
const vi = {
  pdfFailed: "Không tạo được tệp PDF.",
  savedBefore: "{{error}} (đã lưu {{n}} mục trước đó)",
  colFold: "Mở rộng",
};
const zh = {
  pdfFailed: "无法生成 PDF。",
  savedBefore: "{{error}}（此前已保存 {{n}} 项）",
  colFold: "展开",
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "pdfFailed": "Impossible de générer le PDF.",
  "savedBefore": "{{error}} ({{n}} enregistré(s) avant)",
  "colFold": "Développer"
};
const ja = {
  "pdfFailed": "PDFを作成できませんでした。",
  "savedBefore": "{{error}}（これより前に{{n}}件を保存済み）",
  "colFold": "展開"
};

const dictionary = { ns: 'xGtm', en, ko, vi, zh, fr, ja };

export default dictionary;
